/** The table, and the season's best Pokémon by kills */
import { getPokemonStats, getStandings } from '@ogreclan/league-core';
import type { LeagueProps } from '../pages/league';
import { Mon } from '../pokemon';
import { playerName } from './common';

export function StandingsTab({ view, data }: LeagueProps) {
	const { league } = view;
	const standings = getStandings(league);
	const stats = getPokemonStats(league).slice(0, 15);
	return <>
		<div class="card">
			<h2 style="margin-top:0">Standings</h2>
			<div class="table-wrap"><table>
				<thead><tr><th class="num">#</th><th>Player</th><th class="num">Played</th><th class="num">W</th><th class="num">L</th>
					<th class="num">T</th><th class="num">Games</th><th class="num">Kills</th><th class="num">Deaths</th><th class="num">+/−</th></tr></thead>
				<tbody>{standings.map((s, i) => <tr key={s.id} class={s.id === view.you ? 'you' : ''}>
					<td class="num">{i + 1}</td><td>{s.name}</td><td class="num">{s.played}</td><td class="num">{s.wins}</td>
					<td class="num">{s.losses}</td><td class="num">{s.ties}</td><td class="num">{s.gameWins}–{s.gameLosses}</td>
					<td class="num">{s.kills}</td><td class="num">{s.deaths}</td><td class="num">{s.kills - s.deaths > 0 ? '+' : ''}{s.kills - s.deaths}</td>
				</tr>)}</tbody>
			</table></div>
		</div>
		<div class="card">
			<h2 style="margin-top:0">Top Pokémon</h2>
			{stats.length ? <div class="table-wrap"><table>
				<thead><tr><th>Pokémon</th><th>Player</th><th class="num">Games</th><th class="num">Kills</th><th class="num">Deaths</th></tr></thead>
				<tbody>{stats.map(s => <tr key={`${s.player}:${s.species}`} class={s.player === view.you ? 'you' : ''}>
					<td><Mon data={data} id={s.species} /></td><td>{playerName(league, s.player)}</td>
					<td class="num">{s.games}</td><td class="num">{s.kills}</td><td class="num">{s.deaths}</td>
				</tr>)}</tbody>
			</table></div> : <p class="empty">No games played yet.</p>}
		</div>
	</>;
}
